/**
 * Canonical set of languages a tenant can pick for AI-generated warmup send
 * content. Single source of truth — the API DTO derives its allowed-language
 * list from these values, and `LANGUAGE_GENERIC_NAMES` keys off them.
 */
export enum WarmupLanguage {
  English = 'English',
  Spanish = 'Spanish',
  French = 'French',
  German = 'German',
  Portuguese = 'Portuguese',
  Chinese = 'Chinese',
  Japanese = 'Japanese',
  Arabic = 'Arabic',
  Hindi = 'Hindi',
  Russian = 'Russian',
  Italian = 'Italian',
  Dutch = 'Dutch',
}
